import utils from '@/util/utils';

const getInitState = () => {
  return {
    booking: {},
    offers: [],
    offersearch: {},
    partQualityTypes: [],
    selectedOffer: null,
    guilds: [],
    regionSignature: utils.getDefaultSignature(),
    statuses: [{
      key: 'price',
      propName: 'actualGrossRate'
    }, {
      key: 'distance',
      propName: 'distance'
    }, {
      key: 'rating',
      propName: 'userRating'
    }],
    services: [],
    agreements: [],
    additionalServices: []
  }
};

export default {
  getInitState
}
